import { render, staticRenderFns } from "./SmsSend.vue?vue&type=template&id=c60db59e&scoped=true&"
import script from "./SmsSend.vue?vue&type=script&lang=ts&"
export * from "./SmsSend.vue?vue&type=script&lang=ts&"
import style0 from "./SmsSend.vue?vue&type=style&index=0&id=c60db59e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60db59e",
  null
  
)

export default component.exports